<template>
  <div>
    <div class="fine w">
      <div class="fine-title" v-text="param.title"></div>
      <div class="fine-list">
        <!-- <div class="fine-item" v-for="(item,index) in param.list[0].goods_list" :key="index">
					<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank" v-if="index<7">
						<div class="fine-item-img">
							<img class="img-default mark-icon" :src="param.mark_url" alt="" v-if="param.mark_list != -1 && param.mark_url">
							<img class="img-default" :src="item.pic_url" alt="">
						</div>
						<div class="fine-item-txt" v-text="item.name"></div>
					</router-link>
				</div> -->
        <div class="swiper-container swiper1" ref="swipercon">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide fine-item"
              v-for="(item, index) in param.list[0].goods_list"
              :key="index"
            >
              <router-link
                :to="{ path: '/pages/goods/goods', query: { id: item.id } }"
                target="_blank"
                
              >
                <div class="fine-item-img">
                  <img
                    class="img-default mark-icon"
                    :src="param.mark_url"
                    alt=""
                    v-if="param.mark_list != -1 && param.mark_url"
                  />
                  <img class="img-default" :src="item.pic_url" alt="" />
                </div>
                <div class="fine-item-txt" v-text="item.name"></div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  props: {
    param: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  mounted() {
    var mySwiper = new Swiper(".swiper1", {
      freeMode: false,
	  freeModeSticky:false,
      freeModeMomentum: false,
	  slidesPerView:'auto',
    });
	let width=this.param.list[0].goods_list.length*160;
	this.$refs.swipercon.style.width=width+'px';
	// console.log(width)
  },
};
</script>

<style lang="scss" scoped>
.fine {
//   height: 264px;
  height: 288px;
  background-color: #fff;
  margin-top: 20px;
  padding: 0 20px;
  box-sizing: border-box;
  .fine-title {
    height: 60px;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
  }
  .fine-list::-webkit-scrollbar {
    display: none;
  }
  .fine-list {
    margin-top: 10px;
    display: flex;
    // white-space: nowrap;
    // overflow-x:scroll;
    // list-style-type: none;
    // -webkit-overflow-scrolling: touch;
    .fine-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
		width: auto !important;
      a {
        display: block;
      }

      + .fine-item {
        margin-left: 33px;
      }

      .fine-item-img {
        position: relative;
        // height: 136px;
        // width: 136px;
        width: 160px;
        height: 160px;
        .mark-icon {
          position: absolute;
          top: 0;
          left: 0;
          width: 36px;
          height: 36px;
        }
      }

      .fine-item-txt {
        margin-top: 16px;
        // width: 133px;
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        transition: 0.5s;
        -moz-transition: 0.5s;
        -webkit-transition: 0.5s;
        -o-transition: 0.5s;
        font-size: 14px;
      }

      &:hover {
        opacity: 0.8;
      }

      &:hover .fine-item-txt {
        color: #ff0e25;
      }
    }
  }
}
</style>
